import React from 'react';
import { Show, EditButton, TextField, ReferenceManyField, Datagrid, DateField, ReferenceField, Pagination } from 'react-admin';

const StockInEmbedded = ({ permissions, ...props }) => (
    /* Passing " " as title disables the custom title */
    <Show {...props}>
        <ReferenceManyField
                reference="stockins"
                target="stockInRequestId"
                pagination={<Pagination />}
            >
                <Datagrid>
                    <TextField source="id" />
                    <ReferenceField source="appUserId" reference="appusers" label="resources.stockins.fields.user" >
                        <TextField source="username" />
                    </ReferenceField>
                    <TextField source="qty" />
                    <DateField source="stockInDate" />
                    {permissions === 'WM' ? <EditButton /> : "" }
                </Datagrid>
        </ReferenceManyField>
    </Show>
);

StockInEmbedded.propTypes = Show.propTypes;

export default StockInEmbedded;




